<script>
  import { onMount } from "svelte";
  import NavbarUnauthenticated from "#lib/NavbarUnauthenticated.svelte";
  import LaminaIcon from "@local/assets/icons/lamina.svg";
  import isEmail from "@local/extensions/validators/is-email";
  import { acceptInvitation } from "#src/api";

  export let queryParams;

  let errorMessage = null;
  let email = queryParams.email || "";
  let sent = false;
  let showButton = false;

  async function sendEmail(email) {
    if (isEmail(email)) {
      const res = await acceptInvitation(email);
      if (res.error) {
        errorMessage = res.error.message;
      } else {
        sent = true;
      }
    } else {
      errorMessage = "Invalid link.";
    }
  }

  async function submit() {
    await sendEmail(email);
  }

  onMount(async () => {
    await sendEmail(email);
  });
</script>

<NavbarUnauthenticated />
<div class="w-full h-full flex flex-col justify-center">
  <div class="mx-auto w-96 p-4 border rounded bg-white drop-shadow-md">
    <form on:submit|preventDefault={submit} class="space-y-4 text-sm">
      <div class="flex justify-center my-2">
        <LaminaIcon />
      </div>
      <h1 class="text-center">Welcome to Shape Exchange</h1>
      {#if errorMessage}
        <div class="text-red-500 text-center">{errorMessage}</div>
      {:else}
        <div>
          A sign-in link was just sent to <span class="font-bold">{email}</span>.
        </div>
        <div>
          Please find the most recent email from Shape Exchange and click the link to accept your invitation.
        </div>
        <div>
          Didn't receive an email? Check your spam folder or <button
            class="btn-text"
            on:click|preventDefault={() => (showButton = true)}>click to re-send.</button>
        </div>
        {#if showButton}
          <button type="submit" class="btn btn-lg btn-primary w-full"> Re-send Sign-In Link </button>
        {/if}
      {/if}
    </form>
  </div>
</div>
